import { type ComponentProps, type FC, Suspense } from 'react';

import { QueryErrorBoundary } from 'src/libs/Apollo/QueryErrorBoundary';

import { VerificationsErrorState } from './VerificationsErrorState';
import { VerificationsLoadingState } from './VerificationsLoadingState';
import { VerificationsQuery } from './VerificationsQuery';

export const Verifications: FC<ComponentProps<typeof VerificationsQuery>> = ({
  input,
  onCloseVerificationsAlert,
  onClickVerificationsAlertLearnMore,
  onClickVerificationsTabFooterLearnMore,
}) => (
  <QueryErrorBoundary fallback={<VerificationsErrorState />}>
    <Suspense fallback={<VerificationsLoadingState />}>
      <VerificationsQuery
        input={input}
        onCloseVerificationsAlert={onCloseVerificationsAlert}
        onClickVerificationsAlertLearnMore={onClickVerificationsAlertLearnMore}
        onClickVerificationsTabFooterLearnMore={
          onClickVerificationsTabFooterLearnMore
        }
      />
    </Suspense>
  </QueryErrorBoundary>
);
